<template>
    <div>
        <h2>{{$t('message.dashboard_homebases')}}</h2>
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>
                        {{$t('message.serial_number')}}
                    </th>
                    <th>
                        {{$t('message.name')}}
                    </th>
                    <th>
                        {{$t('message.building')}}
                    </th>
                    <th>
                        {{$t('message.active')}}
                    </th>
                    <th>
                        {{$t('message.last_data')}}
                    </th>
                    <th>

                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-if="loading || homebases.length === 0">
                    <table-list-status :loading="loading" :colspan="6" />
                </template>
                <template v-else>
                <tr v-for="homebase in homebases" :key="homebase.id || homebase.serial_number">
                    <td>
                        {{homebase.serial_number}}
                    </td>
                    <td>
                        {{homebase.name}}
                    </td>
                    <td>
                        {{homebase.building.name}}
                    </td>
                    <td>
                        <i class="fa fa-circle" :class="{green: homebase.active, red: !homebase.active}"></i>
                    </td>
                    <td>
                        {{homebase.last_data}}
                    </td>
                    <td>
                        <div class="flex flex-wrap items-center gap-2">
                            <b-btn class="inline-flex items-center gap-2" @click="alarm(homebase)">
                                <i class="fa fa-bell-o" aria-hidden="true"></i>
                                <span>{{$t('message.alarms')}}</span>
                            </b-btn>
                            <b-btn class="inline-flex items-center gap-2" @click="edit(homebase)">
                                <i class="fa fa-edit" aria-hidden="true"></i>
                                <span>{{$t('message.edit')}}</span>
                            </b-btn>
                            <b-btn class="inline-flex items-center gap-2" @click="remove(homebase)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                                <span>{{$t('message.remove')}}</span>
                            </b-btn>
                        </div>
                    </td>
                </tr>
                </template>
            </tbody>
        </table>
        <EditHomebase ref="edit"/>
        <Alarm ref="alarm"/>

        <b-modal v-model="openRemoveModal" :title="$t('message.remove')" id="modal-remove-homebase">
            <div class="space-y-3 pb-1 text-sm leading-relaxed text-gray-700">
                <div v-if="removeItem" class="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800">
                    <div class="font-medium">{{ removeItem.name || removeItem.serial_number }}</div>
                    <div v-if="removeItem.serial_number" class="mt-1 text-gray-600">
                        {{ $t('message.serial_number') }}: {{ removeItem.serial_number }}
                    </div>
                    <div v-if="removeItem.building && removeItem.building.name" class="mt-1 text-gray-500">
                        {{ $t('message.building') }}: {{ removeItem.building.name }}
                    </div>
                </div>
                <p class="m-0">{{ $t('message.confirm_remove_homebase') }}</p>
            </div>
            <template #footer>
                <div class="flex w-full flex-wrap items-center justify-end gap-2">
                    <b-btn @click="openRemoveModal = false">{{ $t('message.no') }}</b-btn>
                    <b-btn type="danger" :disabled="removing" @click="confirmRemove">{{ $t('message.yes') }}</b-btn>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import storage, {HOMEBASE_REQUEST} from '../_store'
    import EditHomebase from './dashboard/modal/EditHomebase'
    import Alarm from './homebases/Alarm.vue'
    import TableListStatus from './TableListStatus'
    import reloadInterval from '../modules/reloadInterval'

    export default {
        name: 'Homebases',
        mixins: [reloadInterval],
        components: {
            EditHomebase,
            Alarm,
            TableListStatus
        },
        data () {
            return {
                loading: true,
                homebases: [],
                openRemoveModal: false,
                removeItem: null,
                removing: false,
                reloadInFlight: false
            }
        },
        methods: {
            edit (item) {
                this.$refs.edit.show(item)
            },
            alarm (item) {
                this.$refs.alarm.show(item)
            },
            remove (item) {
                this.removeItem = item
                this.openRemoveModal = true
            },
            confirmRemove () {
                if (!this.removeItem || this.removing) {
                    return
                }
                this.removing = true
                storage.dispatch(HOMEBASE_REQUEST, {action: 'destroy', homebase: this.removeItem.id})
                    .then(() => {
                        this.openRemoveModal = false
                        this.removeItem = null
                        this.load()
                    }).catch(err => {
                        this.$b_notify({
                            type: 'danger',
                            content: err
                        })
                    }).finally(() => {
                        this.removing = false
                    })
            },
            load (options = {}) {
                const background = options.background === true
                if (this.reloadStopped) {
                    return
                }
                if (background && this.reloadInFlight) {
                    return
                }
                this.reloadInFlight = true
                storage.dispatch(HOMEBASE_REQUEST)
                    .then(resp => {
                        if (this.reloadStopped) {
                            return
                        }
                        this.homebases = resp.data.homebases
                    }).catch(err => {
                        if (background || this.reloadStopped) {
                            return
                        }
                        this.$b_notify({
                            type: 'danger',
                            content: err
                        })
                    }).finally(() => {
                        this.reloadInFlight = false
                        this.loading = false
                    })
            }
        },
        created () {
            this.load()
        },
        mounted () {
            this.startReloadInterval(() => this.load({ background: true }))
        },
        activated () {
            this.startReloadInterval(() => this.load({ background: true }))
        }
    }
</script>

<style scoped>
    .green {
        color: green;
    }
    .red {
        color: red;
    }
</style>
